import { Box, Button, Flex, Heading, Text, useMediaQuery } from '@chakra-ui/react';
import { ArrowForwardIcon, CheckIcon } from '@chakra-ui/icons';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { configFile } from '@/config';
import { handleGTMClick } from '@/helpers/handleGTMClick';

export default function GetToKnowOurTools() {
  const [isMobileScreen] = useMediaQuery('(max-width: 984px)');
  const { t } = useTranslation('services');

  return (
    <Flex
      direction="column"
      maxWidth="1216px"
      margin="0 auto"
      width={{ base: '90%', lg: '100%' }}
      mb="32px"
      gap="72px"
      pt={{ base: '40px', lg: '72px' }}
      pb={{ base: '40px', lg: '72px' }}
    >
      <Box>
        <Heading
          as="h2"
          width="90%"
          fontSize={{ base: '36px', lg: '48px' }}
          lineHeight={{ base: '40px', lg: '48px' }}
          fontWeight="800"
          textAlign="left"
          color="blue.900"
          m="0 auto 16px 0"
          ml={{ base: '0', lg: '0' }}
        >
          {t('digitalAnalytics.getToKnowOurTools.title')}
        </Heading>
        <Text fontSize="16px" lineHeight="24px" color="gray.600">
          {t('digitalAnalytics.getToKnowOurTools.description')}
        </Text>
      </Box>

      <Flex justifyContent="space-between" direction="column" gap="32px">
        {/* ECTO-TOOLS */}
        <Flex
          direction={{ base: 'column', lg: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          p="32px"
          width="100%"
          borderRadius="16px"
          bgColor="gray.100"
          gap={{ base: '32px', lg: '56px' }}
        >
          <Box
            width="100%"
            height="297px"
            position="relative"
            overflow="hidden"
            background="linear-gradient(0deg, rgba(237, 235, 255, 0.2) 0%, rgba(235, 248, 255, 0.2) 100%)"
            borderRadius="8px"
          >
            <Image
              fill
              src="/images/get-to-know-our-tools/illustration1.png"
              style={{ width: '100%', height: '100%' }}
              alt="Ecto Tools"
            />
          </Box>
          <Flex direction="column" gap="16px" alignItems="flex-start" alignSelf="stretch">
            <Text fontSize="24px" lineHeight="32px" fontWeight="700" color="blue.600">
              {t('digitalAnalytics.getToKnowOurTools.ectools.title')}
            </Text>
            <Flex direction="column" gap="32px">
              <Text
                fontSize="16px"
                lineHeight="24px"
                color="gray.600"
                h={{ base: 'auto', lg: '120px' }}
                w={{ base: 'auto', lg: '320px' }}
              >
                {t('digitalAnalytics.getToKnowOurTools.ectools.description')}
              </Text>
            </Flex>
            {/* <Button size="sm" mt={{ base: "16px", lg: "32px" }}>
              {t("digitalAnalytics.getToKnowOurTools.button")}{" "}
              <ArrowForwardIcon />
            </Button> */}
          </Flex>
          <Flex direction="column" gap="24px" w={{ base: '100%', lg: '400px' }}>
            <Flex gap="12px" w={{ base: '100%', lg: '400px' }}>
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.ectools.item1')}
              </Text>
            </Flex>
            <Flex gap="12px">
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.ectools.item2')}
              </Text>
            </Flex>
            <Flex gap="12px">
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.ectools.item3')}
              </Text>
            </Flex>
            <Flex gap="12px">
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.ectools.item4')}
              </Text>
            </Flex>
          </Flex>
        </Flex>

        {/* LOCASTY */}
        <Flex
          direction={{ base: 'column', lg: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          p="32px"
          width="100%"
          borderRadius="16px"
          bgColor="gray.100"
          gap={{ base: '32px', lg: '56px' }}
        >
          {isMobileScreen && (
            <Box
              width="100%"
              height="297px"
              position="relative"
              overflow="hidden"
              background="linear-gradient(0deg, rgba(237, 235, 255, 0.2) 0%, rgba(235, 248, 255, 0.2) 100%)"
              borderRadius="8px"
            >
              <Image
                fill
                src="/images/get-to-know-our-tools/illustration3.png"
                style={{ width: '100%', height: '100%' }}
                alt="Locasty"
              />
            </Box>
          )}
          <Flex direction="column" gap="16px" alignItems="flex-start" alignSelf="stretch">
            <Text fontSize="24px" lineHeight="32px" fontWeight="700" color="blue.600">
              {t('digitalAnalytics.getToKnowOurTools.locasty.title')}
            </Text>
            <Flex direction="column" gap="32px" alignItems="flex-start">
              <Text
                fontSize="16px"
                lineHeight="24px"
                color="gray.600"
                h={{ base: 'auto', lg: '120px' }}
                w={{ base: 'auto', lg: '320px' }}
              >
                {t('digitalAnalytics.getToKnowOurTools.locasty.description')}
              </Text>
              <Button
                id="scenario_locasty"
                onClick={(e) => handleGTMClick(e, () => window.open('https://locasty.com/pt/', '_blank'))}
                aria-label="Locasty page"
                size="sm"
                mt={{ base: '16px', lg: '32px' }}
              >
                {t('digitalAnalytics.getToKnowOurTools.button')} <ArrowForwardIcon />
              </Button>
            </Flex>
          </Flex>
          {!isMobileScreen && (
            <Box
              width="100%"
              height="297px"
              position="relative"
              overflow="hidden"
              background="linear-gradient(0deg, rgba(237, 235, 255, 0.2) 0%, rgba(235, 248, 255, 0.2) 100%)"
              borderRadius="8px"
            >
              <Image
                fill
                src="/images/get-to-know-our-tools/illustration3.png"
                style={{ width: '100%', height: '100%' }}
                alt="Locasty"
              />
            </Box>
          )}
          <Flex direction="column" gap="24px" w={{ base: '100%', lg: '400px' }}>
            <Flex gap="12px" w={{ base: '100%', lg: '400px' }}>
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.locasty.item1')}
              </Text>
            </Flex>
            <Flex gap="12px">
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.locasty.item2')}
              </Text>
            </Flex>
            <Flex gap="12px">
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.locasty.item3')}
              </Text>
            </Flex>
            <Flex gap="12px">
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.locasty.item4')}
              </Text>
            </Flex>
          </Flex>
        </Flex>

        {/* ECTO-HUB */}
        <Flex
          direction={{ base: 'column', lg: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          p="32px"
          width="100%"
          borderRadius="16px"
          bgColor="gray.100"
          gap={{ base: '32px', lg: '56px' }}
        >
          <Box
            width="100%"
            height="297px"
            position="relative"
            overflow="hidden"
            background="linear-gradient(0deg, rgba(237, 235, 255, 0.2) 0%, rgba(235, 248, 255, 0.2) 100%)"
            borderRadius="8px"
          >
            <Image
              fill
              src="/images/get-to-know-our-tools/illustration2.png"
              style={{ width: '100%', height: '100%' }}
              alt="Ecto Hub"
            />
          </Box>
          <Flex direction="column" gap="16px" alignItems="flex-start" alignSelf="stretch">
            <Text fontSize="24px" lineHeight="32px" fontWeight="700" color="blue.600">
              {t('digitalAnalytics.getToKnowOurTools.ectoHub.title')}
            </Text>
            <Flex direction="column" gap="32px" w={{ base: 'auto', lg: '320px' }}>
              <Text fontSize="16px" lineHeight="24px" color="gray.600" h={{ base: 'auto', lg: '120px' }}>
                {t('digitalAnalytics.getToKnowOurTools.ectoHub.description')}
              </Text>
            </Flex>
            {/* <Button size="sm" mt={{ base: "16px", lg: "32px" }}>
              {t("digitalAnalytics.getToKnowOurTools.button")}{" "}
              <ArrowForwardIcon />
            </Button> */}
          </Flex>
          <Flex direction="column" gap="24px" w={{ base: '100%', lg: '400px' }}>
            <Flex gap="12px" w={{ base: '100%', lg: '400px' }}>
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.ectoHub.item1')}
              </Text>
            </Flex>
            <Flex gap="12px">
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.ectoHub.item2')}
              </Text>
            </Flex>
            <Flex gap="12px">
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.ectoHub.item3')}
              </Text>
            </Flex>
            <Flex gap="12px">
              <CheckIcon
                color={configFile.tertiaryAccentColor}
                bgColor="green.500"
                borderRadius="9999px"
                p="3px"
                mt="4px"
              />
              <Text fontSize="16px" lineHeight="24px" color="gray.600">
                {t('digitalAnalytics.getToKnowOurTools.ectoHub.item4')}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
